'use strict';
const mmWidgets = require('./mm-widgets');

mmWidgets.fn.anonymousFilesWidget = function (jsonStorage) {
	if (!jsonStorage) {
		throw new Error('invalid-args');
	}
	return mmWidgets.each(this, function () {
		const element = this,
			listContainer = element.find('[data-mm-role~="file-list-container"]'),
			listItemTemplate = element.find('[data-mm-role~="file-list-template"]').detach();

		listItemTemplate.attr('data-mm-role', false);
		element.on('show', () => {
			const anonymousFileKeys = jsonStorage.getKeysWithPrefix('_free/');
			listContainer.empty();
			anonymousFileKeys.forEach(key => {
				const itemWidget = listItemTemplate.clone(),
					item = jsonStorage.getItem(key),
					savedDate = new Date(item.ts);
				itemWidget.find('[data-mm-role~="anonymous-file-title"]').text(item.title).attr('href', `/map/${key}`);
				itemWidget.find('[data-mm-role~="anonymous-file-ts"]').text(savedDate.toLocaleString());
				itemWidget.appendTo(listContainer);
			});
		});
	});
};
